
export const LoadingSpinner = () => {
  return (
    <div className="flex justify-center py-20">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sergen-500"></div>
    </div>
  );
};
